var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('slide'),_c('all-Courses')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }